//Cancel out the annoying formats for the phone-number
//https://stackoverflow.com/questions/3736807/how-do-i-remove-the-blue-styling-of-telephone-numbers-on-iphone-ios
export const meta = (meta) => {
  meta.addMetaItem([
    //<meta name="format-detection" content="telephone=no">
    { name:'format-detection', content: 'telephone=no' },
  ])
  meta.addAppAttribute([
    { name:"style", value:"height:auto"}
  ])
}

export const extraJS = null

//We need to include this. There should be a separate one for 
//https://csswizardry.com/2020/05/the-fastest-google-fonts/

export const externalCSS = [
  {type:'webfont', href:'https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;900'},
  {type:'webfont', href:"https://fonts.googleapis.com/css2?family=Fira+Sans+Condensed:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap"}
]

